export default __webpack_public_path__ + "static/media/img10.c6f3c6ac.jpeg";